import permCode from '@/config/permCode'
export default [
  {
    permission: permCode.ROSTER_LIST,
    title: '花名册',
    sortOrder: 9,
    icon: 'el-icon-menu',
    url: '/roster/index'
  }
]
